<template>
  <div>
    <div v-if="sidebarData.length !== 0 && !sidebarLoading">
      <div
        v-if="Object.keys(sidebarData[0][sidebarDataField]).length > 0"
        class="d-flex justify-content-between"
      >
        <strong>{{ $t(`stats.${sidebarDataField}`) }}</strong>
        <strong v-if="sidebarDataField === 'revenue'">{{ currency(accountCurrency, countObjectTotals(sidebarData[0][sidebarDataField])) }}</strong>
        <strong v-else>{{ new Intl.NumberFormat('en-GB', { style: 'decimal' }).format(countObjectTotals(sidebarData[0][sidebarDataField])) }}</strong>
      </div>
      <div
        v-else
        class="d-flex justify-content-between"
      >
        <strong>{{ $t(`stats.${sidebarDataField}`) }}</strong>
        <strong v-if="sidebarDataField === 'revenue'">{{ currency(accountCurrency, sidebarData[0][sidebarDataField]) }}</strong>
        <strong v-else>{{ new Intl.NumberFormat('en-GB', { style: 'decimal' }).format(sidebarData[0][sidebarDataField]) }}</strong>
      </div>
      <div
        v-for="item in sidebarData"
        :key="item.date"
      >
        <div v-if="typeof item[sidebarDataField] === 'object' && Object.keys(item).length > 0">
          <div
            v-for="(value, name, idx) in sortObjectByValues(item[sidebarDataField])"
            :key="`${sidebarDataField}${idx}`"
            class="stats-item d-flex justify-content-between ьи"
            :class="{
              even: idx % 2 !== 0,
              odd: idx % 2 === 0
            }"
          >
            <small
              :class="{'text-primary cursor-pointer': name !== 'others'}"
              @click="getSiteById(name)"
            >
              {{ siteNameByIdFromStore(name) }}
            </small>
            <small v-if="sidebarDataField === 'revenue'">{{ currency(accountCurrency, value) }}</small>
            <small v-else>{{ new Intl.NumberFormat('en-GB', { style: 'decimal' }).format(value) }}</small>
          </div>

        </div>
      </div>
    </div>
    <div
      v-else-if="sidebarLoading"
      class="text-center"
    >
      <b-spinner label="Loading..." />
    </div>
  </div>
</template>

<script>
import currencyFormatter from '@/utils/currency-formatter'
import getFormattedDate from '@/utils/date-formatter'
import { getSiteById } from '@/utils/helpers'
import { mapGetters } from 'vuex'

import {
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
  },
  props: {
    sidebarData: {
      type: Array,
      required: true,
    },
    accountCurrency: {
      type: String,
      default: '',
    },
    sidebarDataField: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currency: currencyFormatter,
      getFormattedDate,
      getSiteById,
      sidebarLoading: false,
      toggleData: {
        revenue: [],
        clicks: [],
      },
    }
  },
  computed: {
    ...mapGetters('dashboard-sites-stats', ['siteNameByIdFromStore']),
  },
  watch: {
    sidebarData(newValue) {
      if (newValue.length > 0) {
        this.sidebarLoading = false
      } else {
        this.sidebarLoading = true
        setTimeout(() => { this.sidebarLoading = false }, 1000)
      }
    },
  },
  methods: {
    filteredFields(item) {
      const { clicks, revenue, impressions } = item

      return {
        clicks,
        revenue,
        impressions,
      }
    },
    countObjectTotals(obj) {
      const calc = Object.values(obj).reduce((acc, value) => acc + value, 0)
      return calc.toFixed(2)
    },
    sortObjectByValues(obj) {
      const entries = Object.entries(obj)
      const othersEntry = entries.find(entry => entry[0] === 'others')
      const filteredEntries = entries.filter(entry => entry[0] !== 'others')
      filteredEntries.sort((a, b) => b[1] - a[1])
      if (othersEntry) {
        filteredEntries.push(othersEntry)
      }

      return Object.fromEntries(filteredEntries)
    },
    formatTitle(key) {
      if (key !== 'revenue') {
        return `${this.$i18n.t(`stats.${key}`)} ${this.countObjectTotals(this.sidebarData[key])}`
      }

      return `${key} ${this.currency(this.accountCurrency, this.countObjectTotals(this.sidebarData[key]))}`
    },
    toggleDetails(value, field) {
      const idx = this.toggleData[field].indexOf(value)

      if (idx !== -1) {
        this.toggleData[field].splice(idx, 1)
      } else {
        this.toggleData[field].push(value)
      }
    },
  },
}
</script>

<style scoped>
#modal-stats .stats-item {
  padding: 4px;
  border-top: 1px solid #ebe9f1
}

#modal-stats .stats-item.odd {
  background-color: #fafafc;
}

#modal-stats .stats-item.even {
  background-color: #ffffff;
}
</style>
